var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMechanicalSoftwareArrowDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 263,
    viewBox: "0 0 188 263",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.924 2C125.466 30.4246 90.1946 69.0815 74.3131 121.184C64.6352 152.934 70.8761 187.41 97.2682 208.988C117.738 225.724 137.693 214.171 155.953 198.99C178.312 180.401 198.809 147.828 176.114 121.184C153.294 94.393 95.0042 88.6934 65.9294 104.851C12.5439 134.517 6.82076 203.129 12.8333 256.8",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 233.636C4.77064 240.277 6.25531 247.415 8.77649 254.161C9.61527 256.405 10.0881 258.781 10.9828 260.993",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4014 260.525C13.6544 258.503 14.2839 256.127 15.133 253.927C16.4941 250.399 18.2158 247.08 19.8476 243.677C21.0112 241.251 23.1244 238.422 23.5117 235.741",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanicalSoftwareArrowDark);
export default __webpack_public_path__ + "static/media/mechanical_software_arrow_dark.fd23c64c0843a06e217acb77feb0902c.svg";
export { ForwardRef as ReactComponent };